export default __webpack_public_path__ + "static/media/perfil.a3648d38.png";